jQuery($ => {
	$('aside .accordion-menu > a').click(function (e) {
		e.preventDefault();
		$(this).parent().toggleClass('open').children('ul').slideToggle();
	});
});
